import React, { Fragment } from 'react'
import { Link } from 'gatsby'

import SEO from '../../components/seo'
import Layout from '../../components/layout'
import Servizio from '../../components/Servizio'

import ExpressImg from '../../images/express.jpg'

const paginaServizio = {
  titolo: 'Express',
  parent: null,
  servizi: [
    {
      id: 1,
      nome: '',
      imgUrl: ExpressImg,
      paragrafi: [
        {
          id: 1,
          testo:
            'Express è un servizio aereo espresso che consente di spedire pacchi e documenti in tutto il mondo con consegna a domicilio.',
        },
        {
          id: 2,
          testo:
            'Può contare su aerei dedicati e centri di smistamento internazionali automatizzati.',
        },
        {
          id: 3,
          testo:
            'Garantisce la consegna e il ritiro delle spedizioni fino a 68 kg costituite da uno o più colli in 24 ore dal centro di volo in Europa e nelle principali città USA e in 48 ore dal centro di volo nel resto del mondo.',
        },
      ],
      pesoDimensioni: [
        {
          id: 1,
          descrizione: 'Peso massimo per spedizione',
          valore: '68 kg',
        },
        {
          id: 4,
          descrizione: 'Lunghezza massima',
          valore: '274 cm',
        },
        {
          id: 5,
          descrizione: 'Misure massime per collo',
          valore: '330 cm',
        },
      ],
      vantaggi: [
        {
          id: 1,
          testo: 'Servizio espresso aereo con consegne in tutto il mondo',
        },
        {
          id: 2,
          testo:
            'Tempi di consegna regolari: 24 ore in tutta Europa e nelle più importanti città degli USA; 48 ore in tutte le altre destinazioni',
        },
        {
          id: 3,
          testo:
            'Assicurazione inclusa secondo gli accordi della Convenzione di Varsavia',
        },
        {
          id: 4,
          testo: 'Spedizioni multi-collo',
        },
        {
          id: 5,
          testo:
            'Prenotazione del servizio tramite telefono, e-mail, Weblabeling (per maggiori informazioni contatta la tua Sede di riferimento), o eventualmente via fax',
        },
      ],
      compatibileCon: null,
    },
  ],
}

const Express = () => {
  return (
    <Layout>
      <SEO
        title={paginaServizio.titolo}
        description={paginaServizio.servizi[0].paragrafi[0].testo}
      />
      <section className="py-8 px-6">
        <h1 className="text-3xl sm:text-4xl font-light text-gls-blue-900 leading-tight">
          {!!paginaServizio.parent && (
            <Link
              to={paginaServizio.parent.linkUrl}
              className="mr-2 text-lg text-gls-blue-600 hover:text-gls-blue-700"
            >
              {paginaServizio.parent.nome} &raquo;
            </Link>
          )}
          {paginaServizio.titolo}
        </h1>
      </section>
      <section className="bg-white lg:rounded-lg shadow-xl">
        {paginaServizio.servizi.map((servizio, index) => {
          return (
            <Fragment key={servizio.id}>
              <Servizio servizio={servizio} />
              {index < paginaServizio.servizi.length - 1 && <hr />}
            </Fragment>
          )
        })}
      </section>
    </Layout>
  )
}

export default Express
